<ng-content></ng-content>
<i class="ant-tag-close-icon" *ngIf="nzMode === 'closeable'" (click)="closeTag($event)" ui-icon uiType="close" tabindex="-1"></i>
